export const formApiBaseUrl = process.env.GATSBY_FORM_API_BASE_URL;
